import videos from './videos';

export default {
    render(h) {
        let { attrs, on, props } = this.initData();

        let videoCom = videos.createVideo({ ...attrs });

        if (videoCom.name !== 'defaultVideo') {
            attrs = {};
        }

        return h(videoCom, {
            attrs,
            on,
            ref: 'videoCom',
            props
        });
    },
    props: {
        src: {
            type: String,
            default: ''
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        loop: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        },
        controls: {
            type: Boolean,
            default: false
        },
        playsinline: {
            type: Boolean,
            default: false
        },
        volume: {
            default: null
        },
        loadedmetadata: Function,
        loadeddata: Function,
        canplay: Function,
        pause: Function,
        play: Function,
        ended: Function,
        error: Function,
        seeked: Function
    },
    computed: {
        $video() {
            return this.$refs.videoCom;
        }
    },
    methods: {
        initData() {
            const attrs = {
                src: this.src
            };
            let props = {};
            const emptyFun = () => {};
            const on = {
                click: () => {
                    this.$emit('click');
                },
                loadedmetadata: this.loadedmetadata || emptyFun,
                loadeddata: this.loadeddata || emptyFun,
                canplay: this.canplay || emptyFun,
                pause: this.pause || emptyFun,
                play: this.play || emptyFun,
                ended: this.ended || emptyFun,
                seeked: this.seeked || emptyFun,
                error: this.error || emptyFun,
                ...this.$listeners
            };
            if (this.autoplay) {
                attrs.autoplay = 'autoplay';
            }
            if (this.loop) {
                attrs.loop = 'loop';
            }
            if (this.controls) {
                attrs.controls = 'controls';
            }
            if (this.volume) {
                attrs.volume = this.volume; // Add volume configuration item 
            }
            if (this.playsinline) {
                attrs.playsinline = 'playsinline';
            }

            props = {
                ...attrs,
                muted: this.muted,
                playsinline: this.playsinline
            };

            return { attrs, on, props };
        }
    }
};
